import { Box, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { mockDataRequests } from "../../data/mockData";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import {
  Approval,
  Cancel,
  ImageNotSupportedRounded,
} from "@mui/icons-material";

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "date",
      headerName: "Date",
      cellClassName: "name-column--cell",
    },
    {
      field: "jobName",
      headerName: "Job Name",
      headerAlign: "center",
      align: "left",
      flex: 1,
    },
    {
      field: "jobNo",
      headerName: "Job No",
      headerAlign: "center",
      align: "left",
      flex: 0.5,
    },
    {
      field: "institute",
      headerName: "Institute",
      headerAlign: "center",
      align: "left",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
    },
    {
      field: "jobType",
      headerName: "Job Type",
    },
    {
      field: "note",
      headerName: "Note",
    },
    {
      field: "accessLevel",
      headerName: "Access Level",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: ({ row: { access } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            backgroundColor={colors.greenAccent[600]}
            borderRadius="4px"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                justifyItems: "center",
                padding: "0 10px 0 10px",
              }}
            >
              <IconButton>
                <Approval />
              </IconButton>
              <IconButton>
                <Cancel />
              </IconButton>
              <IconButton>
                <ImageNotSupportedRounded />
              </IconButton>
            </Box>
          </Box>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <Header
        title="Approve Pending Requests"
        subtitle="List of all un-approved requests"
      />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={mockDataRequests}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default Contacts;
